<template>
  <div class="c-adminMenu" v-if="permissions.includes('Admin')">
    <div class="c-adminMenu__menu">
      <div class="c-adminMenu__menu__title">管理メニュー</div>
      <ul class="c-adminMenu__menu__items">
        <li v-for="menu in computeMenus" :key="menu.text">
          <router-link
            v-if="menu.type === 'router'"
            :to="menu.routerTo"
            class="c-adminMenu__menu__item"
            :class="menu.buttonColor === 'red' ? '--red' : ''"
          >
            {{ menu.text }}
          </router-link>
          <a
            v-if="menu.type === 'anchor'"
            :href="menu.href"
            class="c-adminMenu__menu__item"
          >
            {{ menu.text }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    permissions: Array,
  },
  data: function() {
    return {
      menus: {
        Admin: [
          {
            type: "router",
            routerTo: { name: "admin-user" },
            text: "ユーザー管理",
            buttonColor: "red",
          },
          {
            type: "router",
            routerTo: { name: "admin-order" },
            text: "申し込み管理",
          },
          {
            type: "router",
            routerTo: { name: "admin-order-schema" },
            text: "オーダースキーマ管理（zoom専用）",
            buttonColor: "red",
          },
          {
            type: "router",
            routerTo: { name: "admin-event" },
            text: "イベント予約管理",
          },
          // {
          //     "type": "anchor",
          //     "href": "https://www.mansion-concierge.com/mc/survey_list.php",
          //     "text": "アンケート一覧"
          // },
          {
            type: "router",
            routerTo: { name: "admin-allocation-index" },
            text: "抽選管理",
          },
        ],
        AdminAndEventAdmin: [
          {
            type: "router",
            routerTo: { name: "admin_event" },
            text: "イベント予約管理",
          },
        ],
        AdminAndChairman: [
          {
            type: "anchor",
            href: "https://www.mansion-concierge.com/mc/survey_list.php",
            text: "アンケート一覧",
          },
        ],
      },
    };
  },
  computed: {
    computeMenus() {
      if (this.permissions.includes("Admin")) {
        return this.menus["Admin"];
      } else if (
        this.permissions.includes("Admin") &&
        this.permissions.includes("EventAdmin")
      ) {
        return this.menus["AdminAndEventAdmin"];
      } else if (
        this.permissions.includes("Admin") &&
        this.permissions.includes("Chairman")
      ) {
        return this.menus["AdminAndChairman"];
      } else {
        return [];
      }
    },
  },
};
</script>

<style></style>
